import { RoleConstant } from '../constants';
import { RequestAction } from '.';

export const createRole = data =>
  RequestAction.request(RoleConstant.CREATE_ROLE, {
    data,
    method: 'post',
    url: `/api/role`,
  });

export const deleteRole = id =>
  RequestAction.request(RoleConstant.DELETE_ROLE, {
    method: 'delete',
    url: `/api/role/${id}`,
  });

export const editRole = (id, data) =>
  RequestAction.request(RoleConstant.EDIT_ROLE, {
    data,
    method: 'put',
    url: `/api/role/${id}`,
  });

export const getRole = id =>
  RequestAction.request(RoleConstant.GET_ROLE, { url: `/api/role/${id}` });

export const getRoles = params =>
  RequestAction.request(RoleConstant.GET_ROLES, { params, url: '/api/role' }, false);

export const setRole = payload => ({
  payload,
  type: RoleConstant.SET_ROLE,
});

export const setRoles = payload => ({
  payload,
  type: RoleConstant.SET_ROLES,
});
